import * as React from "react";

import { AppSidebar } from "@/components/app-sidebar";
import { AppHeader } from "@/components/app-header";
import { Toaster } from "@/components/ui/sonner";
import { SidebarInset, SidebarProvider } from "@/components/ui/sidebar";
import { ConsultationProvider } from "@/provider/consultation";
import { UIContext } from "@/context/ui";
import { ProjectProvider } from "@/provider/project";
import { useParams } from "react-router-dom";

interface WrapperProps {
  children: React.ReactNode;
}

export const Wrapper = ({ children }: WrapperProps) => {
  const uiContext = React.useContext(UIContext);

  if (!uiContext) {
    throw new Error("Wrapper must be used within a UIProvider");
  }

  const { sidebar } = uiContext;
console.log('sidebar', sidebar)
  return (
    <ProjectProvider>
      <ConsultationProvider>
        <SidebarProvider defaultOpen={sidebar}>
          <div className="flex flex-col w-full h-screen">
            <AppHeader />
            <div className="flex flex-1 overflow-hidden">
              <AppSidebar />
              <SidebarInset>
                <div className="flex flex-1 flex-col p-4">{children}</div>
              </SidebarInset>
            </div>
          </div>
          <Toaster />
        </SidebarProvider>
      </ConsultationProvider>
    </ProjectProvider>
  );
};
